import { starterVenues } from "@anjabom/core";
import { contributionRequest } from "./contribution-client";
export const WATCH_KEY = "anjabom.watched-seats.v1";
export const INBOX_EVENT = "anjabom:inbox-changed";
export interface SeatUpdate {
	id: string;
	at: string;
	text: string;
	href: string;
	seatKey?: string;
}
export function watchedSeats(): string[] {
	try {
		const v = JSON.parse(localStorage.getItem(WATCH_KEY) ?? "[]");
		return Array.isArray(v)
			? v.filter((x): x is string => typeof x === "string").slice(0, 50)
			: [];
	} catch {
		return [];
	}
}
export function watchSeat(key: string): "added" | "limit" | "failed" {
	try {
		const seats = watchedSeats();
		if (seats.includes(key)) return "added";
		if (seats.length >= 5) return "limit";
		localStorage.setItem(WATCH_KEY, JSON.stringify([...seats, key]));
		if (!localStorage.getItem("anjabom.inbox-seen.v1"))
			localStorage.setItem("anjabom.inbox-seen.v1", new Date().toISOString());
		window.dispatchEvent(new Event(INBOX_EVENT));
		return "added";
	} catch {
		return "failed";
	}
}
export function unwatchSeat(key: string) {
	localStorage.setItem(
		WATCH_KEY,
		JSON.stringify(watchedSeats().filter((v) => v !== key)),
	);
	window.dispatchEvent(new Event(INBOX_EVENT));
}
export function cachedUpdates(): SeatUpdate[] {
	try {
		const list = JSON.parse(
			localStorage.getItem("anjabom.inbox-cache.v1") ?? "[]",
		);
		return Array.isArray(list) ? list : [];
	} catch {
		return [];
	}
}
export async function refreshInbox(showTitles: string[] = []) {
	const since =
		localStorage.getItem("anjabom.inbox-seen.v1") ?? new Date().toISOString();
	const result = await contributionRequest<{
		updates: SeatUpdate[];
		checkedAt: string;
	}>("/api/updates", "POST", {
		seatKeys: watchedSeats(),
		venueIds: [],
		showTitles,
		since,
	});
	const requested = JSON.parse(
		localStorage.getItem("anjabom.requested-venues.v1") ?? "[]",
	) as string[];
	const noticed = JSON.parse(
		localStorage.getItem("anjabom.noticed-venues.v1") ?? "[]",
	) as string[];
	const norm = (value: string) =>
		value.normalize("NFKC").replace(/\s/g, "").toLowerCase();
	for (const venue of starterVenues)
		if (
			!noticed.includes(venue.id) &&
			requested.some(
				(name) =>
					norm(name).length >= 2 &&
					(norm(venue.name).includes(norm(name)) ||
						norm(name).includes(norm(venue.name))),
			)
		)
			result.updates.push({
				id: `venue:${venue.id}`,
				at: venue.verifiedAt,
				text: `요청한 ${venue.name}을 이제 목록에서 확인할 수 있어요`,
				href: `/venue/${venue.slug}`,
			});
	localStorage.setItem(
		"anjabom.inbox-cache.v1",
		JSON.stringify(result.updates),
	);
	window.dispatchEvent(new Event(INBOX_EVENT));
	return result.updates;
}
export function markInboxRead() {
	const prior = JSON.parse(
		localStorage.getItem("anjabom.noticed-venues.v1") ?? "[]",
	) as string[];
	localStorage.setItem(
		"anjabom.noticed-venues.v1",
		JSON.stringify([
			...new Set([
				...prior,
				...cachedUpdates()
					.filter((u) => u.id.startsWith("venue:"))
					.map((u) => u.id.slice(6)),
			]),
		]),
	);
	localStorage.setItem("anjabom.inbox-seen.v1", new Date().toISOString());
	localStorage.setItem("anjabom.inbox-cache.v1", "[]");
	window.dispatchEvent(new Event(INBOX_EVENT));
}
